





















































import {
	defineComponent,
	PropType,
	ref,
} from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import { professionalRoleRequired, professionalRoleVerificationRequired } from '@front-app/util/permission';
import { roleVerificationRequestStateStore } from '@front-app/store/singletons/UserVerificationRequest';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size } from '@front-app/components/constants';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import RoleVerificationStepperPanel from '@front-app/modules/user/components/RoleVerificationStepperPanel.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';

const LINK_BUTTON_PROPS = {
	isLink: true,
	wrap: true,
	palette: ButtonPalettes.PRIMARY,
	size: Size.INLINE,
};

const SOLID_BUTTON_PROPS = {
	isSolid: true,
	wrap: true,
	palette: ButtonPalettes.PRIMARY,
	size: Size.LARGE,
};

export default defineComponent({
	components: {
		FontAwesomeIcon,
		PaddedContent,
		CtaButton,
		RoleVerificationStepperPanel,
		SuccessCard,
	},
	props: {
		group: {
			type: Object as PropType<GroupWithCommunity>,
			required: true,
		},
	},
	setup(props) {
		const {
			value: roleVerificationRequestDate,
		} = roleVerificationRequestStateStore;
		const isRoleVerificationStepperOpen = ref(false);
		const onClose = () => {
			isRoleVerificationStepperOpen.value = false;
			GroupsStore.getInstance().fetchGroup(props.group.id, true, true);
		};

		return {
			onClose,
			professionalRoleRequired,
			professionalRoleVerificationRequired,
			roleVerificationRequestDate,
			isRoleVerificationStepperOpen,
			LINK_BUTTON_PROPS,
			SOLID_BUTTON_PROPS,
		};
	},
});
